import { create } from 'zustand';

const defaultState: SpaceHomeStateType = {
    eventBanner: [],
    headerType: '',
    introduction: '',
    menuOrder: [],
    mobileBgColor: {
        mobileCustomBgColor: '',
        mobileTextBannerBgColor: '',
    },
    mobileBgImage: {
        mobileBannerImage: '',
        mobileCustomBgImage: '',
    },
    outLink: [],
    pcBgColor: '',
    pcBgImage: {
        pcBasicBgImage: '',
        pcCustomBgImage: '',
        pcTextBannerProfileImage: '',
    },
    resource: [],
    shoppingEvent: [],
    userId: '',
    userImg: '',
    userName: '',
    videoFeed: [],
    status: 0
};

export const useSpaceHomeStore = create<SpaceHomeStateType & SpaceHomeAction>()((set) => ({
    ...defaultState,
    action: {
        setSpaceHomeState: (_state) => set(() => ({ ..._state })),
        clear: () => set(() => ({ ...defaultState })),
    },
}));

export interface SpaceHomeStateType {
    userId: string;
    userName: string;
    userImg: string;
    introduction: string;
    resource: {
        resourceId: string;
        mediaUrl: string;
        resourceType: string;
        thumbnailUrl: string;
    }[];
    eventBanner: {
        bannerImageUrl: string;
        bannerTitle: string;
        bannerUrl: string;
    }[];
    outLink: {
        selectOption: {
            value: number;
            image: string;
            label: string;
        };
        linkUrl: string;
        linkTitle: string;
        iconLink: string;
        instanceId: string;
        isManual: false;
    }[];
    pcBgImage: {
        pcBasicBgImage: string;
        pcCustomBgImage: string;
        pcTextBannerProfileImage: string;
    };
    menuOrder: string[];
    mobileBgColor: {
        mobileTextBannerBgColor: string;
        mobileCustomBgColor: string;
    };
    headerType: string;
    videoFeed: {
        publishDate: string;
        videoThumbnail: string;
        videoTitle: string;
        videoUrl: string;
        ownerChannelName: string;
    }[];
    mobileBgImage: {
        mobileCustomBgImage: string;
        mobileBannerImage: string;
    };
    pcBgColor: string;
    shoppingEvent: {
        eventTitle: string;
        eventUrl: string;
        finishDate: string;
        finishTime: number;
        startDate: string;
        startTime: number;
    }[]
    status:number
}

interface SpaceHomeAction {
    action: {
        setSpaceHomeState: (state: SpaceHomeStateType) => void;
        clear: () => void;
    };
}
